$(document).ready(function () {
	var wasActive = 0;
	var isDesktop = $(".favbox").length > 0;
	var debounce = 0;
	var likedHosts = [];
	var starttime = time();
	var $speedDate = $("#speeddate");
	var uf = parseInt($speedDate.data("uf"));
	var ab1 = parseInt($speedDate.data("ab1"));
	var signupVariant = parseInt($speedDate.data("sb"));
	var msUntilPopup = 15000;
	var openTimer = null;
	if (uf === 5 || uf === 6) {
		msUntilPopup = 1000;
	}

	if (uf === 3 || uf === 4 || uf === 6) {
		if (!isDesktop && "geolocation" in navigator) {
			var elem = $(".stadt .blinkme");
			var oldtext = elem.html();
			var zip = $(".plznumber");
			var oldzip = zip.html();
			elem.html("Suche Singles in <br />deiner Nähe");
			zip.html("<br/>?????");

			navigator.geolocation.getCurrentPosition(
				function (position) {
					$.ajax({
						type: "GET",
						url:
							"/rest/location/getinfo/" +
							position.coords.latitude +
							"/" +
							position.coords.longitude +
							"/" +
							$(".wohnort").length,
						success: function (result) {
							elem.html(
								result.data.position.name
									? "Suche Singles in <br />" + result.data.position.name
									: oldtext
							);
							zip.html(result.data.position.zip ? result.data.position.name : oldzip);
							var i = 0;
							$(".wohnort").each(function () {
								if (result.data.near && i < result.data.near.length) {
									$(this).html('<i class="fa fa-geopin"></i> aus ' + result.data.near[i++].name);
								} else {
									$(this).html('<i class="fa fa-geopin"></i> aus deiner Nähe');
								}
							});
							radar();
						},
						error: radar,
					});
				},
				function () {
					elem.html(oldtext);
					zip.html(oldzip);
					radar();
				}
			);
		} else {
			radar();
		}
	} else {
		radar();
	}

	function radar() {
		setTimeout(function () {
			$("#intro").hide();
			$("#speeddate").show();
		}, Math.max(0, 4000 - time() + starttime));
	}

	function time() {
		return new Date().getTime();
	}

	function isEmpty() {
		return $(".pola1").length === 0;
	}
	function isLast() {
		return $(".pola2").length === 0;
	}

	function isMatch() {
		if (wasActive > 5 && Math.floor(Math.random() * 10) === 0) showModal(likedHosts.length - 1);
	}

	function makeFavEntry() {
		if (!isDesktop) return;
		var imgs = $(".pola1 img");
		var imgURL = imgs[imgs.length - 1].src;

		$(".favbox").append(
			'<a href="javascript:showModal(' +
				(likedHosts.length - 1) +
				', true);" class="favpics"><img src="' +
				imgURL +
				'" /></a>'
		);
	}

	function saveLikedHost() {
		var pola = $(".pola1").last();
		likedHosts[likedHosts.length] = {
			name: pola.find(".name").text(),
			img: pola.find(".photo img").attr("src"),
			id: pola.data("laid"),
		};
	}

	function startCountdown(timeout) {
		clearTimeout(openTimer);
		openTimer = setTimeout(showBoxCountdown, timeout);
	}

	function showBoxCountdown() {
		if (likedHosts.length === 0) {
			startCountdown(msUntilPopup);
			return;
		}
		showBox();
	}

	function showBox() {
		if (likedHosts.length === 0) {
			showEndModal();
			return;
		}
		showModal(Math.floor(Math.random() * (likedHosts.length - 1)));
	}

	function animate(like) {
		$(".pola1")
			.last()
			.css("z-index", 1000)
			.addClass(like ? "anim-like" : "anim-dislike");
		$(".pola2").removeClass("pola2").addClass("pola1");
		$(".pola3").removeClass("pola3").addClass("pola2");
		$(".pola4").removeClass("pola4").addClass("pola3");
		$(".pola5").first().removeClass("pola5").addClass("pola4");
		setTimeout(
			like
				? function () {
						$(".anim-like").removeClass("pola1").css("display", "none");
				  }
				: function () {
						$(".anim-dislike").remove();
				  },
			350
		);
		wasActive++;
		if (wasActive === 1) startCountdown(msUntilPopup);
		setTimeout(function () {
			debounce--;
		}, 200);
	}

	$(".btn-yes").on("click", function () {
		if (debounce >= 1) return;
		debounce++;

		if (isEmpty()) {
			showEndModal();
			debounce--;
			return;
		}

		saveLikedHost();

		$(".pola1>.stempel").css("display", "block");

		setTimeout(function () {
			if (isLast()) {
				showModal(likedHosts.length - 1);
			} else {
				isMatch();
			}
			makeFavEntry();
			animate(true);
		}, 150);
		return false;
	});

	$(".btn-no").on("click", function () {
		if (debounce >= 1) return;
		debounce++;
		if (isEmpty()) {
			showEndModal();
			debounce--;
			return;
		}

		setTimeout(function () {
			if (isLast()) showBox();
			animate(false);
		}, 0);
		return false;
	});

	function showEndModal() {
		showModal(-1, false);
	}

	function showModal(hostIdx, fav) {
		var closeBtn = !isLast();
		if (uf !== 1 && uf !== 3) {
			closeBtn = !!fav;
		}

		var hostName = "",
			hostImage = "",
			hostId = null,
			hostHtml =
				"<h2>Nichts gefunden?</h2>Melde dich jetzt an und erhalte Kontakt zu tausenden weiteren Singlefrauen.",
			hostSubmit = "Jetzt anmelden";

		if (hostIdx >= 0) {
			var host = likedHosts[hostIdx];
			hostName = host["name"].substring(0, host["name"].indexOf("(")).trim();
			hostId = host["id"];
			hostImage = host["img"];

			var caption = "";
			if (signupVariant === 0) {
				caption = fav
					? "Du willst " + host["name"].trim() + " kennenlernen?"
					: "Du hast ein Match mit " + host["name"].trim() + ".";
				hostHtml = "<h2>Treffer!</h2>" + caption + " Schreibe ihr jetzt eine Nachricht.";
			} else {
				caption = host["name"].trim() + " will dich auch kennenlernen.";
				hostHtml = "<h2>" + caption + "</h2> Ihr habt ein Match. Schreibe ihr jetzt eine Nachricht.";
			}

			hostSubmit = hostName + " kennenlernen";
		} else {
			$("#signup").find("h1").text("Gratis anmelden");
		}

		showSignup("#signup", {
			closeable: closeBtn,
			hostName: ab1 === 0 ? hostName : "",
			laid: ab1 === 2 ? hostId : null,
			hostImage: hostImage,
			hostHTML: hostHtml,
			submitText: hostSubmit,
			onOpen: function () {
				clearTimeout(openTimer);
			},
			onClose: function () {
				startCountdown(msUntilPopup);
			},
		});
	}

	window.showModal = showModal;
});
